import { groupBy } from "lodash-es";
import {
  FilterMenuDropdown,
  FilterMenuDropdownProps,
} from "../FilterMenu/FilterMenuDropdown/FilterMenuDropdown";
import { FilterMenuList } from "../FilterMenu/FilterMenuList/FilterMenuList";
import { FilterMenuOption } from "../FilterMenu";
import { ListItemText, ListSubheader } from "@mui/material";
import { FilterMenuItem } from "../FilterMenu/FilterMenuItem/FilterMenuItem";

export type QuickFilterMenuProps = {
  open: FilterMenuDropdownProps["open"];
  onClose: FilterMenuDropdownProps["onClose"];
  anchorEl: FilterMenuDropdownProps["anchorEl"];
  menuOptions?: FilterMenuOption[];
};

export function QuickFilterMenu({
  open,
  onClose,
  anchorEl,
  menuOptions = [],
}: QuickFilterMenuProps) {
  const groupedOptions = groupBy(menuOptions, (option) => {
    return option.group || "";
  });
  const isGrouped = Object.keys(groupedOptions).some((g) => g.length > 0);

  const menuItems = Object.entries(groupedOptions).flatMap(
    ([label, menuOptions]) => {
      return [
        label ? (
          <ListSubheader
            key={label}
            sx={{
              backgroundColor: "background.default",
              px: 0,
              lineHeight: "32px",
            }}
          >
            {label}
          </ListSubheader>
        ) : undefined,
        menuOptions.map((item) => {
          return (
            <FilterMenuItem
              key={item.label}
              label={item.label}
              value={item.value}
              onClick={() => {
                item.onSelect?.(item);
              }}
              disabled={item.isDisabled}
            >
              <ListItemText primary={item.label} />
            </FilterMenuItem>
          );
        }),
      ];
    },
  );

  return (
    <FilterMenuDropdown
      showKeyboardHint
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      children={
        <FilterMenuList
          sx={{ maxHeight: "400px", m: 0, p: 2, pt: isGrouped ? 0 : 2 }}
          onClick={onClose}
        >
          {menuItems}
        </FilterMenuList>
      }
    />
  );
}

export function loadingMenuOption(param: string, field: string) {
  return {
    param,
    field,
    value: "Loading...",
    label: "Loading...",
    isDisabled: true,
  };
}

export function emptyMenuOption(param: string, field: string) {
  return {
    param,
    field,
    value: "None Available",
    label: "None Available",
    isDisabled: true,
  };
}
